<template>
  <content-loader :height="270" :width="750">
    <rect x="30" y="10" rx="5" ry="5" width="690" height="70" />
    <rect x="30" y="100" rx="5" ry="5" width="690" height="70" />
    <rect x="30" y="190" rx="5" ry="5" width="690" height="70" />
  </content-loader>
</template>

<script>
import ContentLoader from '@/components/contentLoaders/ContentLoader'

export default {
  components: {
    ContentLoader,
  },
}
</script>
